import { fetchBalance } from '../../../services/api/finance';

export const balance = {
    namespaced: true,
    state: {
        balance: 0,
    },
    mutations: {
        save(state, data) {
            state.balance = data;
        },
        debit(state, amount) {
            state.balance -= amount;
        },
        resetState(state) {
            state.balance = 0;
        }
    },
    actions: {
        resetState({ commit }) {
            commit('resetState');
        },
        fetchBalance({ commit, dispatch }) {
            return fetchBalance()
                .then((res) => {
                    commit('save', res.data);

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        debit({ commit }, amount) {
            commit('debit', amount);
        }
    },
    getters: {
        balance({ balance }) {
            return balance;
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/home/balance/store.js